exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".NextStepCard-default-3l-ik .NextStepCard-container-1_F5J{overflow:hidden}.NextStepCard-default-3l-ik p{padding:10px;text-transform:uppercase;color:#546d79;text-align:center}.NextStepCard-default-3l-ik .NextStepCard-expectedCommand-Cv3kO{margin:0;overflow:hidden}.NextStepCard-default-3l-ik .NextStepCard-expectedDuration-16uLJ{margin:0;margin-bottom:-50px;padding-bottom:50px;float:right;border-left:1px solid #d6dde1;font-weight:400}.NextStepCard-default-3l-ik .NextStepCard-expectedDuration-16uLJ small{display:block;font-weight:300;font-size:14px;line-height:14px;text-transform:none;color:#ff5766}.NextStepCard-default-3l-ik .NextStepCard-actors-2YUOH{margin:0;border-top:1px solid #d6dde1;font-size:14px;font-style:italic}.NextStepCard-default-3l-ik .NextStepCard-actors-2YUOH>span:before{content:\" : \"}.NextStepCard-default-3l-ik .NextStepCard-actors-2YUOH>span:first-child:before{content:\"\"}.NextStepCard-default-3l-ik .NextStepCard-actors-2YUOH .NextStepCard-highlight-1oinJ{font-weight:400}.NextStepCard-default-3l-ik .NextStepCard-workflow-ODRB6{text-align:center;text-transform:uppercase;text-overflow:ellipsis;font-weight:700}", ""]);

// exports
exports.locals = {
	"default": "NextStepCard-default-3l-ik",
	"container": "NextStepCard-container-1_F5J",
	"expectedCommand": "NextStepCard-expectedCommand-Cv3kO",
	"expectedDuration": "NextStepCard-expectedDuration-16uLJ",
	"actors": "NextStepCard-actors-2YUOH",
	"highlight": "NextStepCard-highlight-1oinJ",
	"workflow": "NextStepCard-workflow-ODRB6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/workflow/components/NextStepCard.less
// module id = 1785
// module chunks = 0